export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10633.04b5c95f.jpg";